import { FC } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const QR_CODE_SIZE_PX = 148;

// The QR points at the device-aware /app redirect, so one code serves
// both stores and the target stays retunable without reprinting codes.
const APP_DOWNLOAD_QR_URL = `${process.env.NEXT_PUBLIC_HOSTNAME}/app?utm_source=funnel-welcome&utm_medium=qr`;

type AppQrCodeProps = {
  label?: string;
};

const AppQrCode: FC<AppQrCodeProps> = ({ label = 'Scan to get the app' }) => (
  <figure className="flex flex-col items-center gap-3">
    <span className="rounded-2xl border border-neutral-200 bg-white p-3">
      <QRCodeSVG
        value={APP_DOWNLOAD_QR_URL}
        size={QR_CODE_SIZE_PX}
        aria-label="QR code linking to the app download page"
      />
    </span>
    <figcaption className="font-open-sans text-sm text-neutral-600">
      {label}
    </figcaption>
  </figure>
);

export default AppQrCode;
